import { render } from "./RecentDeals.vue?vue&type=template&id=d44c2ee0&scoped=true"
import script from "./RecentDeals.vue?vue&type=script&lang=js"
export * from "./RecentDeals.vue?vue&type=script&lang=js"

import "./RecentDeals.vue?vue&type=style&index=0&id=d44c2ee0&lang=css"
import "./RecentDeals.vue?vue&type=style&index=1&id=d44c2ee0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aiden\\OneDrive - Qismat\\Development\\brydg-bdp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d44c2ee0"]])

export default __exports__